export class FilePreviewData {
  constructor(
    public FileName?: string,
    public FileExtension?: string,
    public FileStream?: any,
    public ContentType?: string,
  ) {}
}
